import {
  computed,
  inject,
  provide,
  reactive,
  readonly,
  ref,
} from 'vue';

import type { CityResponse } from '@/types/Cities';

import type { InjectionKey } from 'vue';

const city = ref<undefined | CityResponse>(undefined);

function setCity (value: CityResponse | undefined) {
  city.value = value;
}

const valueToProvide = readonly(reactive({
  city: computed<CityResponse | undefined>(() => city.value),
  setCity,
}));

const key = Symbol('ChoiceApartmentCity') as InjectionKey<typeof valueToProvide>;

export function provideCityAndChanger () {
  provide(key, valueToProvide);
}

export function injectCityAndChanger (): typeof valueToProvide | undefined {
  const result = inject(key, undefined);

  return result;
}
